'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

import ConversationExample from '../../ConversationExample'
import TimerProgressBar from '../../TimerProgressBar/TimerProgressBar'
import { formatMessages, getDurationForExample } from '../../../../utils/slideHelpers'
import { ContentWithNavigation } from '../ContentWithNavigation'

import type { Conversation, ABTestConfig } from '../newContentTestConfig'

type Props = {
  conversations: Array<Conversation>
  currentConversationIndex: number
  isEducationStarted: boolean
  config: ABTestConfig
  currentSlideIndex: number
  isManualMode: boolean
  onNavigate: (direction: 'prev' | 'next') => void
  onComplete?: () => void
}

export const ConversationSlider = ({
  conversations,
  currentConversationIndex,
  isEducationStarted,
  config,
  currentSlideIndex,
  isManualMode,
  onNavigate,
  onComplete,
}: Props) => {
  const translate = useTranslate('conversation.phishing_first_time_lister_education')
  const asset = useAsset('/assets/phishing-first-time-lister-education')
  const currentConversation = conversations[currentConversationIndex]
  if (!currentConversation) return null

  const shouldShowProgressBar = isEducationStarted && conversations.length > 1
  const formattedMessages = formatMessages(currentConversation.messages, translate, asset)
  const label = config.showConversationLabels
    ? translate('scam_message_example', { index: currentConversationIndex + 1 })
    : ''

  return (
    <ContentWithNavigation
      currentIndex={currentConversationIndex}
      maxIndex={conversations.length - 1}
      onNavigate={onNavigate}
      testId="conversation"
      progressBar={
        shouldShowProgressBar ? (
          <TimerProgressBar
            key={`progress-${currentConversationIndex}-${conversations.length}`}
            duration={getDurationForExample(currentSlideIndex, currentConversationIndex, config)}
            isActive={!isManualMode}
            reset={false}
            totalCount={conversations.length}
            currentIndex={currentConversationIndex}
            isManualMode={isManualMode}
            onComplete={onComplete}
          />
        ) : undefined
      }
    >
      <ConversationExample
        label={label}
        messages={formattedMessages}
        showSpacer={config.showConversationLabels}
      />
    </ContentWithNavigation>
  )
}
